import React from 'react'
import './LeftSideBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
const LeftSideBar = () => {
  return (
    <>
      <div className="left-side-container">
          <a href="https://github.com/Mohammed-Saqib" target='_blank' title='GitHub'><FontAwesomeIcon className='leftSideIcons' icon={faGithub} size='3x'  shake/></a>
          <a href="https://www.linkedin.com/in/mohammed-saqib-756018184" target='_blank' title='LinkedIn'><FontAwesomeIcon className='leftSideIcons' icon={faLinkedin} size='3x'  shake/></a>
          <a href="https://www.instagram.com/saqib_software_developer/" target='_blank' title='Instagram'><FontAwesomeIcon className='leftSideIcons' icon={faInstagram} size='3x'  shake/></a>
          <span></span>
      </div>
    </>
  )
}

export default LeftSideBar;